<div [class]="['modal', classes]" [@showHide]>
  <div class="modal__content">
    <div class="window">
      <ng-template #content></ng-template>
    </div>
  </div>
</div>
